module.exports = __webpack_public_path__ + "static/media/okusb.170afefd.png";